const DEFAULT_FTS_IMAGE_ORIGIN = 'https://api.fts.s.scherer-sa.com.br'
const FTS_IMAGE_PATH_PATTERN = /^\/web\/produto\/\d+\/imagem\/?$/

function parseFtsImageOrigins (rawOrigins) {
  const configured = rawOrigins || DEFAULT_FTS_IMAGE_ORIGIN
  const values = Array.isArray(configured) ? configured : String(configured).split(',')

  return values.reduce((origins, value) => {
    try {
      const parsed = new URL(String(value).trim())
      if (!['http:', 'https:'].includes(parsed.protocol)) return origins
      if (!origins.includes(parsed.origin)) origins.push(parsed.origin)
    } catch {
      // Valores inválidos não devem ampliar silenciosamente a allowlist.
    }
    return origins
  }, [])
}

function getConfiguredFtsImageOrigins () {
  return parseFtsImageOrigins(process.env.VUE_APP_FTS_IMAGE_ORIGINS)
}

function validateFtsImageUrl (imageUrl, allowedOrigins = getConfiguredFtsImageOrigins()) {
  try {
    const parsed = new URL(imageUrl)

    if (parsed.username || parsed.password) {
      return { trusted: false, reason: 'credentials_in_url' }
    }

    if (!allowedOrigins.includes(parsed.origin)) {
      return {
        trusted: false,
        reason: 'origin_not_allowed',
        origin: parsed.origin,
        pathname: parsed.pathname,
      }
    }

    if (!FTS_IMAGE_PATH_PATTERN.test(parsed.pathname)) {
      return {
        trusted: false,
        reason: 'path_not_allowed',
        origin: parsed.origin,
        pathname: parsed.pathname,
      }
    }

    return {
      trusted: true,
      origin: parsed.origin,
      pathname: parsed.pathname,
    }
  } catch {
    return { trusted: false, reason: 'invalid_url' }
  }
}

module.exports = {
  DEFAULT_FTS_IMAGE_ORIGIN,
  parseFtsImageOrigins,
  validateFtsImageUrl,
}
